export const controlPanelInnerRoutePaths = {
  cycles: 'ciclos',
  categories: 'categorias',
  evaluators: 'avaliadores',
} as const;

export const controlPanelRoutePaths = {
  home: '/painel-de-controle',
  cycles: `/painel-de-controle/${controlPanelInnerRoutePaths.cycles}`,
  categories: `/painel-de-controle/${controlPanelInnerRoutePaths.categories}`,
  evaluators: `/painel-de-controle/${controlPanelInnerRoutePaths.evaluators}`,
} as const;
